import { uri } from '../../api-endpoint';
import { IDownloadLinkApiResponse } from '../../type-conversion/download-link/download-link';
import { getTemplateFn } from '../common/base/fetch-without-body-template-fn';

/**
 * @description
 * ファイルのダウンロードURLを取得する。
 * このダウンロードURLは1度リクエストを送信すると失効する。
 */
export const getDownloadLink = (token: string) => (
  projectId: number,
  filetype: 'PDF' | 'CSV'
) =>
  getTemplateFn(
    token,
    uri.projectDownloadResultImage(projectId, filetype),
    IDownloadLinkApiResponse
  );
